<template>
  <v-main>
    <v-row>
      <v-col>
        <v-card-title>
          Program List
          <v-spacer></v-spacer>
        </v-card-title>
      </v-col>
      <v-col>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-form>
      <v-container>
        <v-row>
          <v-col
              cols="12"
              md="4"
          >
            <v-text-field
                v-model="key1"
                label="Key"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
          >
            <v-text-field
                v-model="value1"
                label="Value"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-main>
</template>

<script>
export default {
  name: "ProgramList",
  data() {
    return {
      snackbar: false,
      loadSubdomains: true,
      expanded: [],
      singleExpand: true,
      search: "",
      headers: [
        {text: 'Address', value: "address"},
      ],
      desserts: [],
      dnsRecordPatterns: [],
    }
  },
  mounted() {
    this.axios.post('https://isee.sh:2087/subdomain/data/find/pattern?full=false', {dns_record_patterns: []}).then(response => {
      this.desserts = response.data
      this.loadPrograms = false
    })
  },
}


</script>

<style scoped>


</style>
